import React, { useState, useReducer, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import routerConfig from './router/index';
import RouterUI from '@/router/RouterUI';
import PageLoading from '@/components/BaseComponent/PageLoading';
import AppContext from './common/AppContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import commonHelper from '@/utils/commonHelper';
import { searchPath } from '@/util/stringUtil.ts';
import commonSetting from '@/config/commonSetting';
import Cookies from 'js-cookie';
import qs from 'qs';


function reducer(prevState, action) {
    // reducer will read the value from the latest render
    const { count: prevCount } = prevState;
    const { type, payload } = action;
    if (type === 'tokens') {
        return { ...prevState, tokens: payload };
    } else if (type === 'wxInfo') {
        return { ...prevState, wxInfo: payload };
    } else if (type === 'userInfo') {
        return { ...prevState, userInfo: payload };
    } else if (type === 'tokenInfo') {
        return { ...prevState, tokenInfo: payload };
    } else if (type === 'macAddress') {
        return { ...prevState, macAddress: payload };
    } else if (type === 'diskId') {
        return { ...prevState, diskId: payload };
    } else if (type === 'version') {
        return { ...prevState, version: payload };
    } else if (type === 'clientName') {
        return { ...prevState, clientName: payload };
    } else if (type === 'language') {
        return { ...prevState, language: payload };
    } else if (type === 'deviceInfo') {
        return { ...prevState, deviceInfo: payload };
    } else {
        throw new Error();
    }
}

const App = () => {
    const [loading, setLoading] = useState(false);
    const [state, dispatch] = useReducer(reducer, {
        accountType: commonSetting.ACCOUNT_TYPE,
        productType: commonSetting.PRODUCT_TYPE,
    });
    const history = useHistory();
    const query = qs.parse(history.location.search, { ignoreQueryPrefix: true });
    const getInitialState = async () => {
        let accessToken = ''; // app会有缓存，localStorage里的token不一定是当前用户，需要从easybridge获取
        // let accessToken = commonHelper.getTokens();
        console.log('accessToken', accessToken);
        if (query?.mockToken) {
            accessToken = query?.mockToken;
            commonHelper.setTokens({ accessToken: query?.mockToken });
            dispatch({ type: 'tokens', payload: { accessToken: query?.mockToken } });
        }
        if (query.env) {
            Cookies.set('env', query.env, { domain: commonHelper.getRootDomain(window.location.hostname) });
        }

        if (history.location.pathname && !searchPath(commonSetting.WHITE_PAGE_LIST, history.location.pathname)) {
            if (accessToken) {
                setLoading(false);
            } else {
                await commonHelper.getAppToken();
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    // 从URL参数获取语言
    const getLanguageFromURL = () => {
        if (query?.lang) {
            const urlLang = query.lang;
            // 支持的语言列表
            const supportedLangs = ['zh-TW', 'en-US', 'zh-CN', 'vi-VN', 'id-ID', 'ms-MY', 'th-TH'];
            if (supportedLangs.includes(urlLang)) {
                return urlLang;
            }
        }
        return null;
    };

    // 设置语言
    const setAppLanguage = (language) => {
        console.log('set language', language);
        dispatch({ type: 'language', payload: language });
        try {
            const { default: i18n } = require('@/i18n');
            let i18nLang = 'en-US';
            switch (language) {
                case 'zh-CN':
                    i18nLang = 'zh-CN';
                    break;
                case 'zh-TW':
                    i18nLang = 'zh-TW';
                    break;
                case 'en-US':
                    i18nLang = 'en-US';
                    break;
                case 'vi-VN':
                    i18nLang = 'vi-VN';
                    break;
                case 'id-ID':
                    i18nLang = 'id-ID';
                    break;
                case 'ms-MY':
                    i18nLang = 'ms-MY';
                    break;
                case 'th-TH':
                    i18nLang = 'th-TH';
                    break;
                default:
                    break;
            }
            console.log('i18n language', i18nLang);
            i18n.changeLanguage(i18nLang);
        } catch (e) {
            console.error('i18n change language error', e);
        }
    };

    useEffect(() => {
        const initializeApp = () => {
            setLoading(true);
            getInitialState().then(() => {
                // 优先从URL参数获取语言
                const urlLang = getLanguageFromURL();
                if (urlLang) {
                    setAppLanguage(urlLang);
                } else if (window.getLanguage) {
                    window.getLanguage((result) => {
                        setAppLanguage(result);
                    });
                }
                if (window.getAppVersion) {
                    window.getAppVersion((result) => {
                        console.log('set version', result);
                        dispatch({ type: 'version', payload: result });
                    });
                }
                if (window.getDeviceInfo) {
                    window.getDeviceInfo((result) => {
                        console.log('set device info', result);
                        dispatch({ type: 'deviceInfo', payload: result });
                    });
                }
            });
        };

        initializeApp();
    }, []);

    return (
      <>
        <ThemeProvider>
          <AppContext.Provider value={{ ...state, dispatch }}>
            {
                        loading ? <PageLoading />
                            : <RouterUI routers={routerConfig.routes} />
                    }
          </AppContext.Provider>
        </ThemeProvider>
      </>
    );
};

export default App;
